function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import digitalData from 'digital-data';
import { getState, setState } from '../../../analytics-state.js';
import { SEARCH_RESULTS, PLP_GRID, SEARCH, PRODUCTS_AVAILABILITY, PAGINATION, NUCLEUS, NO_EVENT, FILTER, SORT } from '../../../constants.js';
import { setAnalytics, makeEverythingLowerCase, getContentProducts, getPageTemplate, getABtest, getHeaderCrumb, getCurrentPage, shouldReInitAnalytics, getFilters, initializeFiltersState } from '../../../thd-analytics-utils.js';
import * as util from './util.search.analytics.js';
export function search() {
  const searchInit = function () {
    let {
      output: searchModel
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let noSearchResults = false;
    if (!searchModel) return;
    let {
      experienceName,
      pageTransitionEvent = NO_EVENT
    } = getState();
    if (!experienceName) {
      var _window, _window$experienceMet;
      experienceName = (_window = window) === null || _window === void 0 ? void 0 : (_window$experienceMet = _window.experienceMetadata) === null || _window$experienceMet === void 0 ? void 0 : _window$experienceMet.name;
    }
    const {
      searchReport = {},
      taxonomy = {},
      metadata = {},
      products = [],
      defaultPageSize = '',
      isLocalized = null,
      isBrandPricingPolicyCompliant
    } = searchModel || {};
    if (isLocalized === false) return;
    if ((searchReport === null || searchReport === void 0 ? void 0 : searchReport.totalProducts) === 0 && !!(searchReport !== null && searchReport !== void 0 && searchReport.keyword)) {
      noSearchResults = true;
    }
    const onsiteSearchInfo = util.getOnsiteSearchInfo({
      searchModel,
      experienceName
    });
    const breadCrumbs = util.getBrowseSearchBreadCrumb({
      taxonomy
    });
    let pageLoadEvent = (onsiteSearchInfo === null || onsiteSearchInfo === void 0 ? void 0 : onsiteSearchInfo.numberOfResults) === '0' ? 'no search results' : SEARCH_RESULTS;
    if (noSearchResults) {
      pageLoadEvent = SEARCH_RESULTS; // seems redundant with line 53, remove later?
    }
    const {
      startIndex,
      pageSize,
      sortBy
    } = searchReport || {};
    const currentPage = getCurrentPage(startIndex, pageSize, defaultPageSize);
    if (pageTransitionEvent === PAGINATION) pageLoadEvent = PAGINATION;
    setState(_objectSpread(_objectSpread({}, getState()), {}, {
      pageTransitionEvent: undefined,
      currentPage,
      pageSize,
      sortBy,
      filters: initializeFiltersState({
        appliedDimensions: searchModel === null || searchModel === void 0 ? void 0 : searchModel.appliedDimensions
      })
    }));
    digitalData.content = _objectSpread(_objectSpread({}, digitalData.content), {}, {
      product: getContentProducts(products, '', isBrandPricingPolicyCompliant)
    });
    if (!shouldReInitAnalytics(pageTransitionEvent)) {
      if (pageTransitionEvent === FILTER) {
        LIFE_CYCLE_EVENT_BUS.trigger('filters-refinements.publish', {
          breadCrumbs: taxonomy === null || taxonomy === void 0 ? void 0 : taxonomy.breadCrumbs,
          searchReport,
          metadata
        });
      } else if (pageTransitionEvent === SORT) {
        LIFE_CYCLE_EVENT_BUS.trigger('sort-refinements.publish');
      }
      return;
    }
    digitalData.page = {
      pageInfo: {
        abTest: getABtest({
          experienceName,
          breadCrumbs,
          isCategory: false
        }),
        pageName: noSearchResults ? 'no search results' : SEARCH_RESULTS,
        pageLoadEvent,
        pageType: SEARCH_RESULTS,
        pageTemplate: getPageTemplate(experienceName),
        platform: NUCLEUS
      },
      category: {
        headerCrumb: getHeaderCrumb(taxonomy === null || taxonomy === void 0 ? void 0 : taxonomy.breadCrumbs),
        primaryCategory: SEARCH,
        subCategory1: SEARCH,
        subCategory2: SEARCH
      },
      displayAttributes: {
        pageNumber: currentPage,
        productsAvailability: PRODUCTS_AVAILABILITY,
        sortBy,
        viewType: PLP_GRID
      },
      filter: getFilters({
        appliedDimensions: searchModel === null || searchModel === void 0 ? void 0 : searchModel.appliedDimensions
      }),
      onsiteSearchInfo
    };
    digitalData.page.pageInfo = makeEverythingLowerCase(digitalData.page.pageInfo);
    digitalData.page.category = makeEverythingLowerCase(digitalData.page.category);
    digitalData.page.onsiteSearchInfo = makeEverythingLowerCase(digitalData.page.onsiteSearchInfo);
    setAnalytics(digitalData);
  };
  LIFE_CYCLE_EVENT_BUS.lifeCycle.on('search.new-products', searchInit);
}
//# sourceMappingURL=search.js.map